import Validator from '@/shared/utils/validator'

async function getSingleData(dataKey, filters, networkRepo) {
  Validator.require('dataKey', dataKey, 'string')

  const response = await networkRepo.getSingleData(dataKey, filters)

  return response
}

export default getSingleData
